import React, { useEffect, useState } from "react";
import { Modal } from "../../ui/Modal/Modal";
import styles from "./ModalChooseTariff.module.scss";
import { SquareCheckIcon } from "../../assets/icons/SquareCheckIcon";
import Button from "../../ui/Button/Button";
import { ChevronLeftIcon } from "../../assets/icons/ChevronLeftIcon";
import { WalletIcon } from "../../assets/icons/WalletIcon";
import { CreditCardIcon } from "../../assets/icons/CreditCardIcon";
import { ClipLoader } from "react-spinners";
import { useDispatch, useSelector } from "react-redux";
import {
  buyTariffByBallance,
  buyTariffByCard,
} from "../../utils/api/actions/billing";
import { DoneIcon } from "../../assets/icons/DoneIcon";

const methods = ["С баланса", "Картой/СБП"];

const TariffItem = ({ item, index, selectedTariff, onClick }) => {
  const formatPrice = (price) => {
    return price.toLocaleString("ru-RU");
  };

  return (
    <div
      className={
        selectedTariff?.name === item?.name
          ? styles.tariffItemSelected
          : styles.tariffItem
      }
      onClick={onClick}
    >
      <div className={styles.container}>
        <div className={styles.name}>{item.name}</div>
        <div className={styles.price}>
          {formatPrice(item?.price)} ₽{" "}
          {item?.sale && <div className={styles.sale}>-20%</div>}
        </div>
      </div>

      <div className={styles.selected}>
        <SquareCheckIcon
          width={27}
          height={30}
          fill={selectedTariff?.name === item?.name ? "#35A661" : "inherit"}
        />
      </div>
    </div>
  );
};

const PaymentItem = ({
  item,
  index,
  selectedType,
  onClick,
  disabled,
  error,
  setError,
}) => {
  const handleClickDisableItem = () => {
    setError(true);
  };

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError(false);
      }, 3000);
    }
  }, [error, setError]);

  return (
    <div
      className={`${styles.tariffItem} ${
        selectedType === index ? styles.tariffItemSelected : ""
      } ${disabled && item === "С баланса" ? styles.tariffItemDisabled : ""}`}
      onClick={
        disabled && item === "С баланса" ? handleClickDisableItem : onClick
      }
    >
      <div className={styles.containerPayment}>
        <div className={styles.name}>{item}</div>
        {selectedType === index ? (
          <div className={styles.selected}>
            <SquareCheckIcon
              width={27}
              height={30}
              fill={selectedType === index ? "#35A661" : "inherit"}
            />
          </div>
        ) : (
          <div>
            {item === "С баланса" ? (
              <WalletIcon size={30} fill={"#989898"} />
            ) : (
              <CreditCardIcon width={30} height={26} fill={"#989898"} />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export const ModalChooseTariff = ({ visible, handleClose }) => {
  const dispatch = useDispatch();

  const tariffs = useSelector((state) => state?.billing?.tariffs);
  const billing = useSelector((state) => state?.billing?.data);
  const user = useSelector((state) => state?.user?.data);

  const [selectedTariff, setSelectedTariff] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [activeStep, setActiveStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [disabledPaymentMethod, setDisabledPaymentMethod] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const ballance = billing?.ballance;

  useEffect(() => {
    if (ballance < selectedTariff?.price) {
      setDisabledPaymentMethod(true);
    } else {
      setDisabledPaymentMethod(false);
    }
  }, [selectedTariff, ballance]);

  const tariffId =
    tariffs?.find((tariffItem) => tariffItem.name === "Базовый")?.id ||
    "Тариф не найден";

  const tariffsList = [
    {
      name: "Месяц",
      price: 19900,
      id: tariffId,
    },
    {
      name: "Год",
      price: 202980,
      sale: true,
      id: tariffId,
    },
  ];

  const handleSelectTariff = (tariff) => {
    setSelectedTariff(tariff);
  };

  const handleGoToNextStep = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleSendData = () => {
    setLoading(true);
    let data = {
      tariffId: "5a8887f4-926a-4345-a6c2-571f9d2ec744",
      userId: user.id,
    };
    if (selectedType === 1) {
      dispatch(buyTariffByCard(data, setLoading, handleClose));
    } else if (selectedType === 0) {
      dispatch(buyTariffByBallance(data, setLoading, setSuccess));
    }
  };

  const handleGoToPrevStep = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleSelectTypePayment = (type) => {
    setSelectedType(type);
  };

  useEffect(() => {
    if (!visible) {
      setSelectedTariff(null);
      setSelectedType(null);
      setSuccess(false);
      setActiveStep(1);
    }
  }, [visible]);

  useEffect(() => {
    if (success) {
      setActiveStep(null);
      console.log("work active step", success);
    }
  }, [success]);

  return (
    <Modal visible={visible} handleClose={handleClose}>
      <div className={styles.tariffs}>
        {activeStep && (
          <div className={styles.modalTitle}>
            {activeStep === 2 && (
              <div className={styles.chevron} onClick={handleGoToPrevStep}>
                <ChevronLeftIcon width={13} height={17} fill={"black"} />
              </div>
            )}
            {activeStep === 1 ? "Выберите план" : "Выбор варианта оплаты услуг"}
          </div>
        )}

        <div className={styles.tariffsContainer}>
          {activeStep &&
            (activeStep === 1
              ? tariffsList.map((item, index) => (
                  <TariffItem
                    key={`tariff-${index}`}
                    item={item}
                    index={index}
                    onClick={() => handleSelectTariff(item)}
                    selectedTariff={selectedTariff}
                  />
                ))
              : methods.map((item, index) => (
                  <PaymentItem
                    disabled={disabledPaymentMethod}
                    key={`payment-method-${index}`}
                    item={item}
                    index={index}
                    selectedType={selectedType}
                    onClick={() => handleSelectTypePayment(index)}
                    error={error}
                    setError={setError}
                  />
                )))}

          {success && (
            <div className={styles.successMessageContainer}>
              <DoneIcon size={120} />
              <div className={styles.title}>
                Тариф успешно приобретен и активирован!
              </div>
              <div className={styles.description}>
                Вы можете закрыть это окно
              </div>
            </div>
          )}
          {error && (
            <div className={styles.errorMessage}>
              На балансе недостаточно средств!
            </div>
          )}
        </div>

        {activeStep !== null && (
          <Button
            leftIcon={loading && <ClipLoader size={15} color="white" />}
            className={
              activeStep === 1
                ? selectedTariff === null
                  ? styles.disabled
                  : styles.button
                : selectedType === null
                ? styles.disabled
                : styles.button
            }
            titleClassName={`${styles.buttonTitle} ${
              loading ? styles.margin : ""
            }`}
            title={
              activeStep === 1 ? "Перейти к выбору способа оплаты" : "Оплатить"
            }
            onClick={
              activeStep === 1
                ? selectedTariff !== null || !disabledPaymentMethod
                  ? handleGoToNextStep
                  : undefined
                : selectedType !== null || !disabledPaymentMethod
                ? handleSendData
                : undefined
            }
          />
        )}
      </div>
    </Modal>
  );
};
